<template>
  <el-form-item
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
  >
    <el-radio-group
      v-model="labelResult"
      :disabled="disabled"
      @change="handleRadioChange"
    >
      <el-radio
        v-for="(item, index) in labelList"
        :key="index"
        :label="item"
        :class="labelClass"
      ></el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabRadioGroup',
    mixins: [mixins],
    inject: {
      pageComponent: {
        default: '',
      },
    },
    data() {
      return {
        labelList: [],
        labelResult: null,
        labelMap: {},
        valueMap: {},
      }
    },
    watch: {
      innerValue(val) {
        if (val) {
          this.$nextTick(() => {
            this.setValue(val)
          })
        }
      },
    },
    created() {
      this.fetchData()
      this.$baseEventBus.$on('ComponentReset', () => {
        this.labelResult = []
        this.setModel(null)
      })
    },
    methods: {
      //单击多选框
      handleRadioChange(val) {
        this.setModel(this.labelMap[val])
      },
      setValue(val) {
        setTimeout(() => {
          this.labelResult = this.valueMap[val]
        }, 0)
      },
    },
  }
</script>
